import { OutstreamVideoAdPlayer } from '@tunein/web-player-manager/outstream';
import classNames from 'clsx';
import { api } from 'src/client/api';
import { player } from 'src/client/player';
import useOnMount from 'src/common/hooks/useOnMount';
import css from './OutstreamVideoAd.module.scss';

export function OutstreamVideoAd(props: { id: string; center?: boolean }) {
  const { id, center } = props;

  useOnMount(() => {
    const outstreamVideoAdPlayer = new OutstreamVideoAdPlayer({
      id,
      api: api.instance,
      // To fast-track outstream video ads, we won't wait for Player Manager instantiation, so we can simply pass in the singleton
      playerManager: player,
    });

    return () => {
      outstreamVideoAdPlayer?.destroy();
    };
  });

  return <div id={id} className={classNames(css.container, { [css.center]: center })} />;
}
